module.exports = __webpack_public_path__ + "static/media/map_demographics.f56e4224.png";